import { FC, Fragment, JSX } from 'react';
import { Alert, Box, Button, Card, CardActions, CardContent, Grid } from '@mui/material';
// components
import CheckboxController from 'controller/Checkbox';
import InputController from 'controller/InputController';
// constants, styles, interfaces, helpers, context
import { isSuperAdmin } from 'lib/helper';
import { useAuthContext } from 'contexts/AuthContext';
import { ProductTypeFormProps } from 'interfaces';
import { flexMarginTopEndCenter, forInputLabelBg } from 'styles/commonComponentStyle';
import {
  NAME_TEXT,
  SAVE_TEXT,
  PROPAGATE_TO_ORGANIZATIONS_TEXT,
  PROPAGATE_TO_ORGANIZATIONS_INFO,
} from 'constants/index';

const ProductTypeForm: FC<ProductTypeFormProps> = ({ isEdit = false, loading = false }): JSX.Element => {
  const { userRoles } = useAuthContext();
  // Propagation is a super-admin only action available while editing.
  const canPropagate = isEdit && isSuperAdmin(userRoles);

  return (
    <Card sx={forInputLabelBg}>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12} lg={12}>
            <InputController isRequired fieldType="text" name="name" disabled={loading} title={NAME_TEXT} />
          </Grid>

          {canPropagate ? (
            <Grid item xs={12} lg={12}>
              <CheckboxController
                name="propagateToOrganizations"
                title={PROPAGATE_TO_ORGANIZATIONS_TEXT}
                loading={loading}
              />
              <Alert severity="info" sx={{ mt: 1 }}>
                {PROPAGATE_TO_ORGANIZATIONS_INFO}
              </Alert>
            </Grid>
          ) : (
            <Fragment />
          )}
        </Grid>
      </CardContent>

      {isEdit ? (
        <CardActions>
          <Box sx={flexMarginTopEndCenter}>
            <Button type="submit" variant="contained" size="small" disabled={loading}>
              {SAVE_TEXT}
            </Button>
          </Box>
        </CardActions>
      ) : (
        <Fragment />
      )}
    </Card>
  );
};

export default ProductTypeForm;
